import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CarouselComponent} from './carousel.component';
import {SlideZoneDirective} from './slide-zone.directive';
import {CarouselItemComponent} from './carousel-item.component';
import {CarouselSlideComponent} from './carousel-slide.component';
import {RouterModule} from '@angular/router';
import'hammerjs';
import'hammer-timejs';
export class PacSliderModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule,
        RouterModule
    ],
    declarations: [CarouselComponent, CarouselItemComponent, CarouselSlideComponent, SlideZoneDirective],
    entryComponents: [CarouselSlideComponent],
    exports: [CarouselComponent, CarouselItemComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PacSliderModule_tsickle_Closure_declarations() {
/** @type {?} */
PacSliderModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PacSliderModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
